export enum PassChange {
  IN_PROGRESS,
  SUCCESS,
  FAILURE
}